<rt-dropdown [width]="DropdownWidth">
  @for (option of options; track option.count) {
    <rt-dropdown-item [isSelected]="option.isSelected" (click)="select(option.count)">
      <rt-icon prefix [name]="option.icon"></rt-icon>
      {{ option.label | translate }}
    </rt-dropdown-item>
  }
</rt-dropdown>
